import React from 'react';
import { ErrorMessage, ErrorMessageProps } from 'formik';


export const MensagemErro: React.FunctionComponent<ErrorMessageProps> = (props) => {
  return <ErrorMessage {...props}>{msg => <div className={`formulario-legenda erro ${props.className}`}>{msg}</div>}</ErrorMessage>
}
